// extracted by mini-css-extract-plugin
export default {"buttons":"Hotels_buttons__NsiUc"};